import React, {Fragment} from 'react';
import Icon from "../../Icon";
import {Button} from "../../Button";
import Avatar from "../../Avatar";
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {sendEnrollmentEmail, updateUserEmail} from "../../../../creators/signup";
import {fetchCurrentUser} from "../../../../creators/currentUser";
import logo_gmail from "../../../../images/logo-gmail.png";
import logo_yaoo from "../../../../images/logo-yahoo.png";
import logo_outlook from "../../../../images/logo-outlook.png";
import logo_orange from "../../../../images/logo-orange.png";
import logo_laposte from "../../../../images/logo-laposte.png";
import Modal from "../../Modal";
import _ from 'lodash';
import {SpinLoader} from "../../Loader";

class EmailValidation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showUpdateEmail: false,
            sendMail : false,
            email: _.get(this.props.currentUser, "email.address") || ""
        };
        this.handleInput = this.handleInput.bind(this);
        this.sendMail = this.sendMail.bind(this);
        this.webmail = this.webmail.bind(this);
        if(!this.props.signup){
            // localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`, true);
            sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`, true);
        }
    }

    handleInput(name, value) {
        this.setState({[name]: value});
    }

    sendMail(){
        if(!this.state.sendMail){
            this.props.sendEnrollmentEmail();
            this.setState({sendMail : true});
            setTimeout(() =>this.setState({sendMail : false}), 10000);
        }

    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        this.setState({showUpdateEmail: false});
        this.props.updateUserEmail({email: this.state.email});
    }

    webmail() {
        if (this.state.email) {
            let domain = this.state.email.substring(this.state.email.indexOf("@") + 1, this.state.email.lastIndexOf("."));
            let webmail = {
                "gmail" : {
                    image: logo_gmail,
                    href: "https://www.gmail.com"
                },
                "yahoo" : {
                    image: logo_yaoo,
                    href: "https://mail.yahoo.com"
                },
                "hotmail" : {
                    image: logo_outlook,
                    href: "https://outlook.com"
                },
                "live" : {
                    image: logo_outlook,
                    href: "https://outlook.com"
                },
                "outlook" : {
                    image: logo_outlook,
                    href: "https://outlook.com"
                },
                "orange" : {
                    image: logo_orange,
                    href: "https://messagerie.orange.fr"
                },
                "wanadoo" : {
                    image: logo_orange,
                    href: "https://messagerie.orange.fr"
                },
                "laposte" : {
                    image: logo_laposte,
                    href: "https://www.laposte.net/accueil"
                }
            };
           return webmail[domain] || false;
        }
        return false
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        /*if(!this.props.currentUserLoading && _.get(prevProps.currentUser,"role") !== _.get(this.props.currentUser,"role") && _.get(this.props.currentUser,"role") !== "emailUnconfirmed"){

            /*window.setTimeout(()=>{
                window.location.reload();
            },3000);*/
        /*}
        /*if(this.props.toggle && !prevProps.toggle){
            console.log("fetchUser");
            this.props.fetchCurrentUser();
        }*/
    }


    render() {
        let ctaEmail = this.webmail();
        return (
            <Modal toggle={this.props.toggle}
                   handleClose={() => this.props.handleClose()}>

                <div id={"emailValidation"}>
                    <div className={"container"}>
                        <div className={"card"}>
                            <div className={"email-topline"}>
                                <div className={"icon-wrapper"}><Icon type={"confetti"}/></div>
                                <span className={"validate-email"}>Bienvenue sur Voissa !</span>
                            </div>
                            {this.props.currentUserInitialized && this.props.currentUserLoading ? (<div className={"load-page"}><SpinLoader className={"small"}/></div> ) :
                                (
                                    _.get(this.props,"currentUser.role") === "emailUnconfirmed" ? (<Fragment>
                                    <form className={"content"} onSubmit={(e) => this.handleSubmit(e)}>
                                        <Avatar gender={this.props.currentUser.profile && this.props.currentUser.profile.gender} avatar={this.props.currentUser.profile && this.props.currentUser.profile.avatar}/>
                                        <span className={"username"}>{this.props.currentUser.username}</span>
                                        {this.props.signup.error && this.props.signup.error.errors && this.props.signup.error.errors.email ? <span className="warning">{this.props.signup.error.errors.email}</span> : <span className={"check-email"}>Vous devez confirmer votre inscription en cliquant sur le lien de vérification qui a été envoyé par email à <span
                                            className={"my-email"}>
                                                {ctaEmail ? (<a href={ctaEmail.href} target={"_blank"} rel="noopener noreferrer nofollow">{this.state.email || _.get(this.props.currentUser, "email.address")}</a>) : this.state.email || _.get(this.props.currentUser, "email.address") }
                                            </span></span>}

                                        {ctaEmail && (<span className={"username"}><a href={ctaEmail.href} target={"_blank"}
                                                                                      rel="noopener noreferrer nofollow"><img
                                            src={ctaEmail.image} alt={"Voir vos Emails"}/> </a></span>)}
                                        {this.state.showUpdateEmail ? (
                                            <Fragment>
                                                <span className={"email-not-received"}>Votre nouvelle adresse email</span>
                                                <input type={"email"} required={true}
                                                       onChange={(event) => this.handleInput("email", event.target.value)}
                                                       className={"email-not-received"} placeholder={"Votre Adresse Email"}/>
                                                <div className={"modify-email-btn-group"}>
                                                    <Button btnStyle={"grey"}
                                                            size={"small"}
                                                            onClick={() => this.setState({showUpdateEmail: false})}
                                                            content={"Annuler"}/>
                                                    <Button btnStyle={"primary-reverse"}
                                                            btnType={"submit"}
                                                            size={"small"}
                                                            content={"Enregistrer"}/>
                                                </div>
                                            </Fragment>
                                        ) : (
                                            this.props.signup.error && this.props.signup.error.errors && this.props.signup.error.errors.email ?
                                                    <Fragment><span className={"separator"}> </span><div className={"email-modifications-btn"}
                                                         onClick={() => this.setState({showUpdateEmail: true})}>modifier l'email
                                                    </div></Fragment>
                                                 : (<Fragment>
                                                    <span className={"email-not-received"}>Vous n’avez pas reçu l’email?</span>
                                                    <div className={"email-modifications-btn"} onClick={() =>this.sendMail()}>Renvoyer l'email d'activation</div>
                                                    {this.state.sendMail ? (<div className={"success"}>Un nouvel e-mail vient de partir</div>) : null }
                                                    <span className={"separator"}>ou</span>
                                                    <div className={"email-modifications-btn"}
                                                         onClick={() => this.setState({showUpdateEmail: true})}>modifier l'email
                                                    </div>
                                                </Fragment>)
                                        )}
                                    </form>
                                    <div className={"email-informations"}>
                                        <ul>
                                            <li>Pensez à vérifier vos spams.</li>
                                            <li>Si vous ne recevez pas l’email après 10 minutes, veuillez <a
                                                href={"/contact"}>contacter</a> notre support
                                            </li>
                                        </ul>
                                    </div>

                                    </Fragment>)
                                     : (
                                        <div className={"load-page p-16"}>Votre compte est confirmé<br />Vous allez pouvoir utiliser toutes les options d'ici quelques secondes...</div>
                                    )
                                )}
                            <Button size="medium"
                                    onClick={() => this.props.handleClose()}
                                    btnStyle="grey"
                                    content="Fermer"/>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

EmailValidation.defaultProps = {
    toggle: true,
    handleClose: () => {
    }
}

const mapStateToProps = state => ({
    signup: state.signup,
    currentUser: state.currentUser.data,
    currentUserLoading: state.currentUser.loading,
    currentUserInitialized: state.currentUser.initialized
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateUserEmail,
    sendEnrollmentEmail,
    fetchCurrentUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EmailValidation);
